<template>
  <div class="landing-page">
    <section class="aboutus-section">
      <div class="tile">
        <h1>
          {{ $t("imprint") }}
        </h1>

        <p>
          Betreiber:<br />
          Tuemedia IT Solutions<br />
          Frederik Reiff<br />
          Claushof 43<br />
          46535 Dinslaken<br /><br />
          Kontakt:<br />
          Telefon: +49 (0) 15733356316<br />
          E-Mail: info@chronofox.de<br /><br />
          Vertreten durch:<br />
          Frederik Reiff<br />
          E-Mail: frederik.reiff@tuemedia-consulting.de<br /><br />
          Umsatzsteuer-ID:<br />
          Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz:
          DE352918460<br /><br />
          Die Datenschutzerklärung finden Sie
          <a href="/legal/privacy" style="text-decoration: underline">hier</a>.
        </p>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: "website",
});

const { t } = useI18n();
useSeoMeta({
  title: t("imprint") + " - " + "ChronoFox",
});
</script>

<style scoped>
.landing-page {
  background-color: var(--primary-background-color);
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  position: relative;
  min-height: 100vh;
}

.aboutus-section {
  padding: 80px 5% 80px 5%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: linear-gradient(
    135deg,
    var(--primary-background-color),
    var(--secondary-text-color)
  );
  background-size: cover;
  background-position: center;
  min-height: 100vh;
}

.tile {
  width: 100%;
  max-width: 900px;
  padding: 50px 40px;
  background-color: var(--secondary-background-color);
  border-radius: 15px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.tile h1 {
  font-size: 3rem;
  font-weight: 700;
  color: var(--t-accent);
  margin: 0 0 2.5rem 0;
  width: 100%;
  text-align: center;
  padding-bottom: 1rem;
  border-bottom: 3px solid var(--t-accent);
}

.tile h1 .highlighted {
  color: var(--secondary-text-color);
}

.tile h2 {
  font-size: 1.4rem;
  font-weight: 700;
  color: #2b2b2b;
  margin-top: 15px;
}

.tile p {
  color: #2c3e50;
  font-size: 1.1rem;
  line-height: 1.9;
  width: 100%;
}

.tile a {
  color: var(--t-accent);
  font-weight: 600;
  transition: all 0.3s ease;
}

.tile a:hover {
  color: var(--secondary-text-color);
}

@media (max-width: 768px) {
  .aboutus-section {
    padding: 40px 5%;
  }

  .tile {
    padding: 30px 25px;
  }

  .tile h1 {
    font-size: 2.2rem;
    margin-bottom: 1.5rem;
  }

  .tile p {
    font-size: 1rem;
  }
}
</style>
